


import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";

import MessageComponent from '@/shared/components/Message.vue'
import ResultsListComponent from '../ResultsList/ResultsList.vue';
import TabComponent from '../Tabs/Tab.vue';
import TabsComponent from '../Tabs/Tabs.vue';

@Component({
    components: {
        MessageComponent,
        ResultsListComponent,
        TabComponent,
        TabsComponent
    },
    computed: {
        ...mapGetters(["searchResults", "employeeResults", "loadEmployeeResults", "searchQuery", "loading", "config", "externalSearchEnabled"])
    },
})
export default class ResultsOverlayComponent extends Vue {
    get searchTabTitle(): string {
        let tabTitle: string = this.$store.getters.config.labels.tabTitle;

        if(!tabTitle) {
            return "VUWeb";
        }

        let count: number = this.$store.getters.searchResults?.count ?? 0;
        return tabTitle.replace("{0}", count.toString()).replace("{1}", this.resultLabel(count));
    }

    get employeeTabTitle(): string {
        let tabTitle: string = this.$store.getters.config.labels.tabTitle_employee;

        if(!tabTitle) {
            return "ServiceNow";
        }

        let count: number = this.$store.getters.employeeResults?.count ?? 0;
        return tabTitle.replace("{0}", count.toString()).replace("{1}", this.resultLabel(count));
    }
   
    private resultLabel(count: number): string {
        return count == 1 ? this.$store.getters.config.labels.result : this.$store.getters.config.labels.results;
    }
}
